import React, { useState, useEffect } from 'react';

const Dashboard = ({ onClose }) => {
  const [stats, setStats] = useState({
    total_locations: 0,
    total_reports: 0,
    reports_by_severity: [],
    top_categories: [],
    recent_reports: [],
    reports_by_day: [],
    active_users: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('http://45.32.108.70:5001/api/dashboard/stats')
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setStats(data.data);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        right: 0,
        width: '400px',
        height: '100vh',
        background: 'rgba(15, 23, 42, 0.98)',
        backdropFilter: 'blur(12px)',
        borderLeft: '1px solid #334155',
        zIndex: 999,
        padding: '20px',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        ⏳ ဒေတာများ စုဆောင်းနေသည်...
      </div>
    );
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      right: 0,
      width: '400px',
      height: '100vh',
      background: 'rgba(15, 23, 42, 0.98)',
      backdropFilter: 'blur(12px)',
      borderLeft: '1px solid #334155',
      zIndex: 999,
      padding: '20px',
      overflowY: 'auto',
      color: 'white'
    }}>
      <button 
        onClick={onClose}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          background: '#ef4444',
          border: 'none',
          borderRadius: '50%',
          width: '30px',
          height: '30px',
          color: 'white',
          fontSize: '16px',
          cursor: 'pointer'
        }}
      >
        ✕
      </button>

      <h2 style={{ marginBottom: '20px', color: '#3b82f6' }}>📊 Dashboard</h2>
      
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '30px' }}>
        <div style={{ background: '#1e293b', padding: '15px', borderRadius: '12px', textAlign: 'center' }}>
          <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#3b82f6' }}>{stats.total_locations}</div>
          <div style={{ fontSize: '12px', color: '#94a3b8' }}>စုစုပေါင်းနေရာ</div>
        </div>
        <div style={{ background: '#1e293b', padding: '15px', borderRadius: '12px', textAlign: 'center' }}>
          <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#f59e0b' }}>{stats.total_reports}</div>
          <div style={{ fontSize: '12px', color: '#94a3b8' }}>စုစုပေါင်းအစီရင်ခံစာ</div>
        </div>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3 style={{ fontSize: '14px', marginBottom: '10px' }}>🏷️ ထိပ်ဆုံး အမျိုးအစားများ</h3>
        {stats.top_categories.map((cat, idx) => (
          <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #334155' }}>
            <span>{cat.category}</span>
            <span style={{ color: '#3b82f6' }}>{cat.count}</span>
          </div>
        ))}
      </div>

      <div>
        <h3 style={{ fontSize: '14px', marginBottom: '10px' }}>📋 နောက်ဆုံး အစီရင်ခံစာများ</h3>
        {stats.recent_reports.slice(0, 5).map((report, idx) => (
          <div key={idx} style={{ background: '#1e293b', padding: '10px', borderRadius: '8px', marginBottom: '8px' }}>
            <div style={{ fontWeight: 'bold', fontSize: '13px' }}>{report.title}</div>
            <div style={{ fontSize: '11px', color: '#94a3b8' }}>
              {report.severity} • {new Date(report.created_at).toLocaleDateString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;